module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('admin-form', {
    attrs: {
      "admin": _vm.admin,
      "create": false
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-648072de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/admins/AdminEdit.vue
// module id = 543
// module chunks = 0